import { render } from "./invoice-template.vue?vue&type=template&id=eb240f84"
import script from "./invoice-template.vue?vue&type=script&lang=js"
export * from "./invoice-template.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__